export default [
  {
    path: '/fcp-logs',
    name: 'FCPLogList',
    component: () => import('@pages/FCPLogs.vue'),
    meta: {
      permissions: [
        {
          role: 'Guest',
          access: false,
          redirect: 'Home',
        },
      ],
    },
  },
  {
    path: '/fcp-logs/preview/:uniqueId/:fileName',
    name: 'FCPLogPreview',
    component: () => import('@pages/FCPLogPreview.vue'),
    meta: {
      permissions: [
        {
          role: 'Guest',
          access: false,
          redirect: 'Home',
        },
      ],
    },
  },
];
